import axios from '@/utils/axios'

export function getSiteInspections(page = 1, params = {}) {
    return axios.get('/site-inspections', {
        params: { page, ...params },
        responseType: params.export ? 'blob' : 'json'
    })
}

export function getSiteInspectionStats() {
    return axios.get('/site-inspections/stats')
}

export function getSiteInspection(id) {
    return axios.get(`/site-inspections/${id}`)
}

export function createSiteInspection(data) {
    return axios.post('/site-inspections', data)
}

export function assignSiteInspector(id, data) {
    return axios.put(`/site-inspections/${id}/assign-site-inspector`, data)
}

export function uploadSiteInspectionDocuments(id, formData) {
    return axios.post(`/site-inspections/${id}/documents`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

export function deleteSiteInspection(id) {
    return axios.delete(`/site-inspections/${id}`)
}